export type LocationItem = {
  id: string;
  name: string;
  label?: string;
  streetAddress?: string | null;
  streetAddress2?: string | null;
  city?: string | null;
  state?: string | null;
  zip?: string | null;
  country?: string | null;
  latitude: number | null;
  longitude: number | null;
  category?: 'saved' | 'cached' | 'searched' | 'recent';
  savedAddressIdentifier?: string;
  source?: 'saved' | 'recent' | 'search';
  occurredAt?: string;
  locationId?: string | null;
  zoneId?: string | null;
  venueId?: string | null;
};

export type RideHistoryRow = {
  id: number;
  createdAt: string;
  startLocation: string | null;
  startLat: number | null;
  startLong: number | null;
  startName: string | null;
  driverCancels?: number | null;
};

export type RawPlaceSearchResult = {
  placeId: string;
  prediction: google.maps.places.AutocompletePrediction;
  details: google.maps.places.PlaceResult;
};

export interface RideStop {
  streetAddress: string;
  city: string;
  state: string;
  zip: string;
  lat: number;
  lng: number;
  type?: string;
  googlePlaceId?: string;
}

export type RideOrderData = {
  rideCostId: string;
  rideType: string;
  callerId?: string;
  altCallerId?: string;
  phoneNumber?: string;
  riderPhone?: string;
  seatCount?: number;
  startLat?: number;
  startLong?: number;
  startingAddress?: string;
  startLocationId?: string;
  startZoneId?: string;
  startVenueId?: string;
  startName?: string;
  destinationLat?: number;
  destinationLng?: number;
  destination?: string;
  destinationName?: string;
  partnerId?: string;
  noteToDriver?: string;
  isEmergency?: number;
  emergencyReason?: string;
  overrideBigCar?: boolean;
  overrideSmallCar?: boolean;
  overrideBannedCar?: boolean;
  overrideBadDriver?: boolean;
  operatorNote?: string;
  reason?: string;
  customRiderName?: string;
  serviceType?: string;
  minutesToAutoRetryRequest?: number;
  minutesToAutoRetryRequestType?: string;
  isDoNotApplySubsidy?: boolean;
  isDoNotApplyExpiringCredits?: boolean;
  isChargeRideOperatingFee?: boolean;
  destinations?: { stops: RideStop[] };
  isMedicalTrip?: boolean;
  partnerRidePurpose?: string;
  storedLongRideOrderDataKey?: string;
};

export type OrderedRideDetail = {
  eta?: string;
  driverName?: string;
  driverPhone?: string;
  driverPlate?: string;
  startLocation?: string;
  destination?: string;
  endLocation?: string;
  createdAt?: string;
  carImage?: string;
  message?: string;
  rideStatus?: string;
  carBrand?: string;
  carModel?: string;
  carColor?: string;
  mapUrl?: string;
  car?: string;
};

export type RideFormData = {
  phoneNumber?: string;
  riderPhone?: string;
  serviceType: string;
  rideType: string;
  rideName?: string;
  minutesBeforeCustomReminder?: number;
  minutesAfterCreationCustomReminder?: number;
  callToConfirmSurge?: 'yes' | 'no' | null;
  scheduleKind?: 'single' | 'multi' | 'willcall' | 'appointment';
  pickupDate?: Date | null;
  pickupTime?: Date | null;
  repeatEveryXWeek?: number;
  day0?: boolean;
  day1?: boolean;
  day2?: boolean;
  day3?: boolean;
  day4?: boolean;
  day5?: boolean;
  day6?: boolean;
  endOnType?: 'never' | 'after' | 'on';
  endAfterXTimes?: number;
  endOn?: Date | null;
  scheduledAppointmentDate?: Date | null;
  scheduledAppointmentTime?: Date | null;
  scheduledAppointmentBufferMinutes?: number;
  nextPickupDate?: string;
  isEmergency?: boolean;
  isDoNotApplySubsidy?: boolean;
  isDoNotApplyExpiringCredits?: boolean;
  minutesToAutoRetryRequest?: number;
  minutesToAutoRetryRequestType?: string;
  overrideBigCar?: boolean;
  overrideSmallCar?: boolean;
  overrideBannedCar?: boolean;
  overrideBadDriver?: boolean;
  operatorNote?: string;
  reason?: string;
  isMedicalTrip?: boolean;
};

export enum RideOrderingStep {
  Location = 'location',
  Estimate = 'estimate',
  Order = 'order',
}
